/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const updatePolicyPlanRequestBlockThresholdMin = 0;
export const updatePolicyPlanRequestBlockThresholdMax = 1;

export const updatePolicyPlanRequestReviewThresholdMin = 0;
export const updatePolicyPlanRequestReviewThresholdMax = 1;

export const updatePolicyPlanRequestSeverityMax = 5;

export const UpdatePolicyPlanRequest = zod
	.object({
		action_canvas: zod.record(zod.string(), zod.unknown()).optional(),
		block_threshold: zod
			.number()
			.min(updatePolicyPlanRequestBlockThresholdMin)
			.max(updatePolicyPlanRequestBlockThresholdMax)
			.optional()
			.describe('Block threshold as a decimal'),
		display_name: zod.string().nullish().describe('Policy plan display name'),
		formats: zod
			.array(zod.enum(['text', 'image']))
			.optional()
			.describe('Content formats'),
		review_threshold: zod
			.number()
			.min(updatePolicyPlanRequestReviewThresholdMin)
			.max(updatePolicyPlanRequestReviewThresholdMax)
			.optional()
			.describe('Review threshold as a decimal'),
		severity: zod
			.number()
			.min(1)
			.max(updatePolicyPlanRequestSeverityMax)
			.nullish()
			.describe('Severity level (1-5)')
	})
	.describe('Request body for updating a policy plan');

export type UpdatePolicyPlanRequest = zod.input<typeof UpdatePolicyPlanRequest>;
export type UpdatePolicyPlanRequestOutput = zod.output<typeof UpdatePolicyPlanRequest>;
